module.exports = __webpack_public_path__ + "img/setpwd.31483a83.png";